import React from 'react';

import img1 from '../img/acompanian/vector-3d.png';
import img2 from '../img/acompanian/TP3D.png';
import img3 from '../img/acompanian/hellen-keller.png';
import img4 from '../img/acompanian/ucorci.png';
import img5 from '../img/acompanian/biblioteca-discapacidades-visuales.png';
import img6 from '../img/acompanian/ministerior-educacion.png';

export default function Acompanian() { 
    

  return (
      <React.Fragment>
          <div className="mt-5 mb-5 referencia text-center">ACOMPAÑAN</div>
          <ul className="acompanian">
            <li><a href="http://vectortresde.com.ar/" target="_blank" rel="noreferrer noopener"><img src={img1} alt="Vector 3D" /></a></li>
            <li><a href="https://www.tp3d.com.ar/" target="_blank" rel="noreferrer noopener"><img src={img2} alt="TP3D" /></a></li>
            <li><a href="https://www.facebook.com/institutohelenkellercba/" target="_blank" rel="noreferrer noopener"><img src={img3} alt="Hellen Keller" /></a></li>
            <li><a href="https://www.facebook.com/Ucorci-1732516820364418/" target="_blank" rel="noreferrer noopener"><img src={img4} alt="ucorci" /></a></li>
            <li><a href="https://www.facebook.com/bibliodisvisualescbacultura/" target="_blank" rel="noreferrer noopener"><img src={img5} alt="biblioteca discapacidades visuales" /></a></li>
            <li><a href="https://www.cba.gov.ar/reparticion/ministerio-de-educacion/" target="_blank" rel="noreferrer noopener"><img src={img6} alt="ministeri educacion" /></a></li>
        </ul>
      </React.Fragment>
    
  );
}